import {Action} from '@domain/action';

/**
 * Actions
 */
export const FRAIS_CARTE_FROM_MENU = 'FRAIS_CARTE_FROM_MENU';

/**
 * Interface
 */
export interface FraisCarteState {
    /** Clic sur le bouton des frais cartes dans le menu */
    fraisCarteData?: any
}

/**
 * Reducer pour l'écoute de l'évènement de clic sur le bouton des frais cartes dans le menu latéral
 */
export function fraisCarteReducer(state: FraisCarteState = {},action: Action<any>): FraisCarteState {
    //Vérification du type d'action
    if (action.type == FRAIS_CARTE_FROM_MENU) {
        //Mise à jour de l'état
        state = {
            ...state,
            fraisCarteData: action.payload
        };
    }

    //Retour de l'état
    return state;
}
